import { cx } from "./cx.js";

/**
 * What a skeleton stands in for, and so the size it takes:
 * `text` is one line of the surrounding text (its height follows the font it sits in),
 * `badge`, `button`, `button-sm`, `input`, `switch` and `select` match those controls,
 * `block` and `circle` take the width and height they are given.
 */
export type SkeletonShape = "text" | "block" | "circle" | "badge" | "button" | "button-sm" | "input" | "switch" | "select";

/** A placeholder for something still loading. Decorative: the page around it says that it is loading. */
export function Skeleton({ shape = "text", width, height, className }: { shape?: SkeletonShape; width?: number | string; height?: number | string; className?: string }) {
  return (
    <span className={cx("dt-skeleton", `dt-skeleton--${shape}`, className)} style={{ width, height }} aria-hidden="true">
      {shape === "text" ? " " : null}
    </span>
  );
}
